import React from 'react';
import { Box } from '@mui/material';
import { Video } from 'lucide-react';
import { PARTICIPANT_PAGE_SIZE } from '../../constants';
import type { IInterviewItem } from '../../interfaces';
import { CardSkeletonGrid, EmptyState, ParticipantPagination } from '../components';

export interface IInterviewsTabProps {
  interviews: IInterviewItem[] | null;
  totalCount: number;
  loading: boolean;
  page: number;
  onPageChange: (page: number) => void;
}

export const InterviewsTab = ({
  interviews,
  totalCount,
  loading,
  page,
  onPageChange,
}: IInterviewsTabProps) => {
  if (loading) {
    return <CardSkeletonGrid count={4} height={180} />;
  }

  if (!interviews || interviews.length === 0) {
    return (
      <EmptyState
        icon={Video}
        title="No Interviews Yet"
        subtitle="Your scheduled interviews will appear here."
      />
    );
  }

  return (
    <>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: '1fr',
            md: 'repeat(2, 1fr)',
            lg: 'repeat(3, 1fr)',
          },
          gap: 3,
        }}
      >
        {/* Interview cards render here once the item shape is finalized. */}
      </Box>
      <ParticipantPagination
        page={page}
        totalCount={totalCount}
        pageSize={PARTICIPANT_PAGE_SIZE}
        onPageChange={onPageChange}
      />
    </>
  );
};
